"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Creates an array of style properties for intent configs
 *
 * @param {String} prop - Property name
 * @param {Number} amount - Amount of properties
 * @returns {Array<String>} - An array of style properties
 */

function createPropertyOrder(prop, amount) {
  return Array(amount).fill(prop).map((p, i) => prop + i);
}
var _default = createPropertyOrder;
exports.default = _default;